import { classNamesFunction } from '@fluentui/react';
import * as React from 'react';
import { getDonutChartAnimationStyles } from './donut-chart-loading-animation.styles';
const getClassNames = classNamesFunction();
export const DonutChartLoadingAnimationBase = (props) => {
    const classNames = getClassNames(getDonutChartAnimationStyles, { theme: props.theme });
    return (React.createElement("svg", { className: classNames.root, viewBox: "0 0 63 63" },
        React.createElement("circle", { className: classNames.circleBase, r: "25%", cx: "50%", cy: "50%" }),
        React.createElement("circle", { className: classNames.firstCircle, r: "25%", cx: "50%", cy: "50%" }),
        React.createElement("circle", { className: classNames.secondCircle, r: "25%", cx: "50%", cy: "50%" })));
};
//# sourceMappingURL=donut-chart-loading-animation.base.js.map